// On crée une fonction vide qui ne fera rien.

  console.info(
    '%c🤫 Logs de la console désactivés en production.',
    'background: #222; color: #bada55; padding: 2px 5px; border-radius: 3px; font-weight: bold;'
  );
  
  const emptyFunction = () => {};

  // On sauvegarde l'objet console original au cas où, mais ce n'est pas obligatoire.
  window.originalConsole = { ...window.console };

  // On remplace chaque méthode de la console par la fonction vide.
  window.console = {
    log: emptyFunction,
    debug: emptyFunction,
    info: emptyFunction,
    warn: emptyFunction,
    error: emptyFunction,
    assert: emptyFunction,
    clear: emptyFunction,
    count: emptyFunction,
    countReset: emptyFunction,
    dir: emptyFunction,
    dirxml: emptyFunction,
    group: emptyFunction,
    groupCollapsed: emptyFunction,
    groupEnd: emptyFunction,
    table: emptyFunction,
    time: emptyFunction,
    timeEnd: emptyFunction,
    timeLog: emptyFunction,
    timeStamp: emptyFunction,
    trace: emptyFunction,
    profile: emptyFunction,
    profileEnd: emptyFunction,
  };
